// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@awc/App/SharedStyles/CartLineSharedStyles";
import { orderLinesListStyles } from "@awc/Overrides/Components/OrderLinesList";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { mergeWithCss, xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

orderLinesListStyles.productBrandStyles = {
    nameLink: {
        css: css`
            @media print {
                width: 80%;
            }
        `,
    },
    nameText: {
        css: css`
            @media print {
                width: 80%;
            }
        `,
    },
};

orderLinesListStyles.productDescriptionStyles = {
    ...cartLineSharedStyles.productDescription,
};

orderLinesListStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};

orderLinesListStyles.productImageLink = {
    ...mergeWithCss(cartLineSharedStyles.productImage?.linkWrappingImage, {
        css: css`
            ${xScreen("lte", "sm")} {
                width: 114px;
                height: 114px;
            }
        `,
    }),
};

orderLinesListStyles.orderLineCardImage = {
    height: "114px",
    width: "114px",
};

orderLinesListStyles.priceWrapper = {
    css: css`
        @media print {
            float: left;
        }
    `,
};
orderLinesListStyles.productInfoSubtotalHeadingAndText = {
    ...mergeWithCss(cartLineSharedStyles.extendedUnitNetPriceText, {
        extendedStyles: {
            heading: {
                css: css`
                    ${xScreen("lte", "md")} {
                        display: inline-block;
                        word-break: keep-all;
                        margin-bottom: 0;
                        line-height: ${fontConfig.lineHeight.small};
                        &:after {
                            content: ":";
                        }
                    }
                    @media print {
                        margin-right: 12px;
                    }
                `,
            },
            text: {
                css: css`
                    line-height: ${fontConfig.lineHeight.small};
                    @media print {
                        display: inline;
                    }
                `,
            },
            wrapper: {
                css: css`
                    flex-direction: row;
                    gap: 10px;
                    @media print {
                        display: block;
                    }
                `,
            },
        },
    }),
};

orderLinesListStyles.subtotalWithoutVatHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

orderLinesListStyles.priceHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

orderLinesListStyles.unitOfMeasure = {
    ...mergeWithCss(cartLineSharedStyles.unitOfMeasure, {
        css: css`
            display: inline-flex;
            line-height: ${fontConfig.lineHeight.xSmall};
            margin-left: 4px;
        `,
    }),
};

orderLinesListStyles.addToListLink = {
    ...mergeWithCss(cartLineSharedStyles.addToListLink, {
        css: css`
            margin-top: 18px;
        `,
    }),
};

orderLinesListStyles.lableText = {
    ...mergeWithCss(cartLineSharedStyles.qtyLabel, {
        css: css`
            ${xScreen("gt", "md")} {
                display: block;
            }
        `,
    }),
};

orderLinesListStyles.qtyOrderedField = {
    valueText: {
        weight: fontConfig.weight.regular,
        css: css`
            margin-bottom: 12px;
        `,
    },
    qtyLabel: {
        weight: fontConfig.weight.regular,
        css: css`
            display: none;
            ${xScreen("lte", "md")} {
                display: inline-block;
            }
            @media print {
                display: inline-block;
            }
        `,
    },
};

orderLinesListStyles.qtyShippedField = {
    qtyLabel: {
        weight: fontConfig.weight.regular,
        css: css`
            display: none;
            ${xScreen("lte", "md")} {
                display: inline-block;
            }
            @media print {
                display: inline-block;
            }
        `,
    },
    valueText: {
        weight: fontConfig.weight.regular,
    },
};

orderLinesListStyles.productInfoSectionOptionsGridItem = {
    ...cartLineSharedStyles.promotionsContainer,
};

orderLinesListStyles.productInfoSectionOptionsLableText = {
    ...cartLineSharedStyles.configurationOptionLabel,
};

orderLinesListStyles.productInfoSectionOptionsValueText = {
    ...cartLineSharedStyles.configurationOptionText,
};

orderLinesListStyles.promotionNameLabel = {
    ...cartLineSharedStyles.promotionNameLabel,
};

orderLinesListStyles.orderLineInfoPromotionText = {
    ...cartLineSharedStyles.promotionNameText,
};

orderLinesListStyles.promotionsContainer = {
    ...cartLineSharedStyles.promotionsContainer,
};

orderLinesListStyles.productQtyContainer = {
    css: css`
        @media print {
            display: table;
            content: "";
            clear: both;
            width: 100%;
            max-width: 250px;
            > div:first-child {
                float: left;
                padding-right: 40px;
            }
        }
    `,
};

orderLinesListStyles.priceHeading = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.heading,
};

orderLinesListStyles.priceText = {
    ...mergeWithCss(cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.text, {
        weight: fontConfig.weight.regular,
        css: css`
            display: inline-flex;
            width: auto;
        `,
    }),
};

orderLinesListStyles.unitOfMeasure = {
    ...mergeWithCss(cartLineSharedStyles.unitOfMeasure, {
        css: css`
            display: inline-flex;
            line-height: ${fontConfig.lineHeight.xSmall};
            margin-left: 4px;
        `,
    }),
};

orderLinesListStyles.productOrderPriceContainer = {
    css: css`
        @media print {
            display: block;
            text-align: left;
        }
    `,
};

orderLinesListStyles.cartLineContainerStyles = {
    container: {
        css: css`
            grid-template-columns: 2fr 4fr repeat(4, 1fr);
            ${xScreen("lte", "lg")} {
                grid-template-columns: 2fr 4fr repeat(4, 1fr);
            }
            ${xScreen("lte", "md")} {
                grid-template-columns: 1fr 5fr 2fr;
                row-gap: 0;
            }
        `,
    },
    image: {
        css: css`
            display: flex;
            justify-content: center;
            ${xScreen("lte", "md")} {
                grid-column: 1 / 2;
                grid-row: 1 / 5;
            }
        `,
    },
    description: {
        css: css`
            grid-column: 2 / 3;
            ${xScreen("lte", "sm")} {
                grid-column: 2 / 4;
                grid-row: 1 / 2;
                margin-bottom: 8px;
            }
        `,
    },
    price: {
        css: css`
            grid-column: 3 / 4;
            grid-row: 1 / 2;
            ${xScreen("lte", "md")} {
                grid-column: 3 / 4;
                grid-row: 3 / 4;
                text-align: right;
            }
            ${xScreen("lte", "sm")} {
                grid-column: 2 / 4;
                grid-row: 2 / 3;
                text-align: left;
            }
            @media print {
                width: 40%;
            }
        `,
    },
    qty: {
        css: css`
            grid-column: 4 / 5;
            grid-row: 1 / 2;
            text-align: center;
            ${xScreen("lte", "md")} {
                grid-column: 3 / 4;
                grid-row: 4 / 5;
                text-align: right;
            }
            ${xScreen("lte", "sm")} {
                grid-column: 2 / 4;
                grid-row: 3 / 4;
                text-align: left;
            }
        `,
    },
    total: {
        css: css`
            grid-column: 6 / 7;
            grid-row: 1 / 2;
            ${xScreen("lte", "md")} {
                grid-column: 3 / 4;
                grid-row: 6 / 7;
            }
            ${xScreen("lte", "sm")} {
                grid-column: 2 / 4;
                grid-row: 5 / 6;
                justify-content: start;
            }
        `,
    },
    notes: {
        css: css`
            grid-column: 2 / 7;
            grid-row: 2 / 3;
            ${xScreen("lte", "md")} {
                grid-column: 1 / 3;
                grid-row: 6 / 7;
            }
            ${xScreen("lte", "sm")} {
                grid-column: 1 / 4;
                grid-row: 6 / 7;
            }
        `,
    },
    remove: {
        css: css`
            grid-column: 5 / 6;
            grid-row: 1 / 2;
            ${xScreen("lte", "md")} {
                grid-row: 5 / 6;
                grid-column: 3 / 4;
            }
            ${xScreen("lte", "sm")} {
                grid-column: 2 / 4;
                grid-row: 4 / 5;
                justify-content: start;
            }
            @media print {
                min-width: 60%;
                display: block;
                float: right;
            }
        `,
    },
};

orderLinesListStyles.cartLineNotesStyle = {
    readOnlyNotesText: {
        wrapper: {
            css: css`
                flex-direction: row;
                align-items: baseline;
                gap: 8px;
                ${xScreen("lte", "sm")} {
                    margin-top: 5px;
                }
            `,
        },
        heading: {
            color: "secondary",
            size: fontConfig.fontSize.small,
            weight: fontConfig.weight.bold,
            lineHeight: fontConfig.lineHeight.singleLineSmall,
            css: css`
                text-transform: capitalize;
                &:after {
                    content: ":";
                }
            `,
        },
        text: {
            css: css`
                width: auto;
            `,
        },
    },
};
